import { FormControlLabel as MuiFormControlLabel, formControlLabelClasses as muiFormControlLabelClasses, } from '@mui/material';
export const FormControlLabel = MuiFormControlLabel;
export const formControlLabelClasses = muiFormControlLabelClasses;
